import React, { FunctionComponent, useContext, useEffect } from 'react';
import {
  CurrentUserContext,
  CurrentUserContextProps,
} from '/src/contexts/shared/CurrentUserContext';
import {
  PostContext,
  PostContextProps,
  PAGINATION_STEP,
} from '/src/contexts/PostContext';
import { Club } from '/src/domain/club/ClubData';
import { PostView } from '/src/ui/studentTasks/studentTasks/posts/PostView';
import { Box } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DialogProgress } from '/src/ui/studentTasks/studentTasks/actions/DialogProgress';
import { PageStub } from '/src/ui/shared/PageStub';
import { useTranslation } from 'react-i18next';

interface AudioPostsListsProps {
  userClub: Club | null;
}

export const AudioPostsLists: FunctionComponent<AudioPostsListsProps> = ({
  userClub,
}) => {
  const { t } = useTranslation();
  const { currentUser, currentDate } = useContext(
    CurrentUserContext,
  ) as CurrentUserContextProps;
  const { audioPostsByStatus, requestPostsByStatus, saveAudioMark } =
    useContext(PostContext) as PostContextProps;

  useEffect(() => {
    requestPostsByStatus({
      type: 'audios',
      club: userClub,
      from: audioPostsByStatus.offset,
      limit: PAGINATION_STEP,
    });
  }, []);

  useEffect(() => {
    // установить счётчик новых аудио постов на самый новый пост
    if (!audioPostsByStatus.offset && audioPostsByStatus.posts?.[0]?.postid) {
      saveAudioMark(audioPostsByStatus.posts[0].postid, 0, false);
    }
  }, [audioPostsByStatus]);

  if (audioPostsByStatus.posts === undefined) {
    return <DialogProgress />;
  }

  return (
    <Box>
      {audioPostsByStatus.posts?.length ? (
        <InfiniteScroll
          dataLength={audioPostsByStatus.posts.length}
          next={() =>
            requestPostsByStatus({
              type: 'audios',
              club: userClub,
              from: audioPostsByStatus.offset,
              limit: PAGINATION_STEP,
            })
          }
          hasMore={audioPostsByStatus.hasMore}
          loader={<DialogProgress />}
        >
          {audioPostsByStatus.posts.map((p) => {
            if (!p.userid) return null;

            return (
              <PostView
                key={p.postid}
                {...p}
                currentDate={currentDate}
                isReadOnly={true}
                isPreview
                type={'post'}
                currentUserId={currentUser?.id}
                userInfo={p.userInfo}
                isRepostAvailable={Boolean(
                  p.userInfo?.currentTrainerId === currentUser?.id,
                )}
                isRepostedPost={false}
                userClub={userClub}
                isShortHeader={false}
              />
            );
          })}
        </InfiniteScroll>
      ) : (
        <PageStub text={t('noPosts')} />
      )}
    </Box>
  );
};
